module.exports = __webpack_public_path__ + "img/slides-mepyd-11@2x.9f51c1ce.png";